import React from 'react';

function PrivacyPolicy() {
    return (
        <div className="privacy-policy-container">
            <h1>Irontrack Mobile Application Privacy Policy</h1>
            <p><strong>Last Updated:</strong> September 29, 2026</p>

            <h2>Introduction</h2>
            <p>
                Welcome to the Irontrack mobile application. We value your privacy and are committed to
                protecting your personal information. This Privacy Policy explains how we collect, use,
                and safeguard information that we may collect from or about you when you use our
                Irontrack mobile application ("App").
            </p>

            <h2>Information Collection and Use</h2>

            <h3>Nature of Our App</h3>
            <p>
                The Irontrack mobile application is a simple WebView-based app that loads and displays
                the website www.irontrack.ee. The App itself does not independently collect, store, or
                process user data.
            </p>

            <h3>Internet Connection Usage</h3>
            <p>
                The App requires internet connectivity to load the website www.irontrack.ee. An internet
                connection is necessary to use the App, but we do not collect or store any data about
                your internet connection or network activity.
            </p>

            <h3>Website Privacy Policy</h3>
            <p>
                Since the App merely serves as a tool to display the www.irontrack.ee website, any data
                you enter on the website is subject to the privacy policies of the www.irontrack.ee/privacy-policy website.
                We recommend that you review the website's privacy policy to understand how your data is
                processed on the website.
            </p>

            <h2>Third-Party Services</h2>

            <h3>Google Play Services</h3>
            <p>
                If you download the App from the Google Play Store, Google may collect certain information
                about the download, installation, and usage of the App according to their privacy policies.
                We do not use Google services (e.g., Google Analytics) to track usage within the App.
            </p>

            <h2>Children's Privacy</h2>
            <p>
                You may create an account through the website if you are at least 16 years old. Our App
                and services are not intended for children under the age of 16, and we do not knowingly
                collect personal information from children under 16. If you are a parent or guardian and
                believe a child under 16 has provided us with personal information, please contact us at
                info@irontrack.ee and we will delete that information.
            </p>

            <h2>Changes to This Privacy Policy</h2>
            <p>
                We may update our Privacy Policy from time to time. We advise you to review this Privacy
                Policy periodically for any changes. Changes to this Privacy Policy are effective when they
                are posted in this document.
            </p>

            <h2>Contact Us</h2>
            <p>
                If you have any questions or suggestions about our Privacy Policy, please contact us at:
            </p>
            <p>
                Sander Prii<br />
                Email: prii.sander@gmail.com<br />
                Address: lehe 10-1, räni, kambja vald, tartumaa<br />
                Phone: +37253328647
            </p>

            <hr />

            <p>
                This Privacy Policy has been prepared in accordance with relevant data protection laws,
                including the European Union General Data Protection Regulation (GDPR) and other
                applicable laws.
            </p>
        </div>
    );
}

export default PrivacyPolicy;